import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import SectionMessage from '@atlaskit/section-message';
import { GET_APP_NAME } from '../web-client';
export var SANDBOX_DEPRECATION_ERROR = 'INVALID_INVOCATION_RUNTIME_ERROR';
var buildMessage = function buildMessage(title, error) {
  if (error === SANDBOX_DEPRECATION_ERROR) {
    return "Your app ".concat(title, " is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.");
  }
  return "".concat(title, " version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.");
};
export var ForgeDeprecationMessage = function ForgeDeprecationMessage(props) {
  var client = props.client,
    extension = props.extension,
    error = props.error;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    appName = _useState2[0],
    setAppName = _useState2[1];
  useEffect(function () {
    if (client) {
      var response = client.query({
        query: GET_APP_NAME,
        variables: {
          id: extension.id
        }
      });
      response.then(function (data) {
        var _data$data;
        var appName = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.app.name;
        setAppName(appName);
      });
    }
  }, [client, extension.id]);
  var title = appName ? appName : extension.properties.title;
  var message = buildMessage(title, error);
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: "App update required",
    appearance: "error"
  }, message);
};